import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { BookingButton } from './BookingButton';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsMobileMenuOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);
  const navLinks = [{
    name: 'Acasă',
    path: '/'
  }, {
    name: 'Consultanță',
    path: '/magazin'
  }, {
    name: 'Despre Mine',
    path: '/despremine'
  }, {
    name: 'Testimoniale',
    path: '/testimoniale'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  return <header className={`fixed top-0 left-0 w-full z-50 bg-[#09111F] transition-all duration-300 ${isScrolled ? 'py-4 shadow-lg' : 'py-6'}`} data-id="element-110">
      <div className="max-w-[1200px] mx-auto px-5 md:px-12 flex items-center justify-between" data-id="element-111">
        <Link to="/" className="font-['Montserrat'] text-xl font-bold text-white tracking-tight z-50" data-id="element-112">
          Valer Dura
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-6" data-id="element-113">
          <div className="flex items-center gap-5" data-id="element-114">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`font-['Inter'] text-[14px] transition-colors ${location.pathname === link.path ? 'text-white font-medium' : 'text-[rgba(255,255,255,0.7)] hover:text-white'}`} data-id="element-115">
                {link.name}
              </Link>)}
          </div>
          <BookingButton text="Diagnostic Gratuit" className="px-5 py-2.5 text-[13px]" data-id="element-116" />
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden text-white z-50 p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-117">
          {isMobileMenuOpen ? <X size={24} data-id="element-118" /> : <Menu size={24} data-id="element-119" />}
        </button>

        {/* Mobile Nav */}
        <div className={`fixed inset-0 bg-[#09111F] z-40 flex flex-col pt-24 px-6 transition-transform duration-300 lg:hidden ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`} data-id="element-120">
          <div className="flex flex-col gap-4 overflow-y-auto pb-24" data-id="element-121">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`font-['Montserrat'] text-lg py-2 border-b border-[rgba(255,255,255,0.05)] ${location.pathname === link.path ? 'text-white font-bold' : 'text-[rgba(255,255,255,0.7)]'}`} data-id="element-122">
                {link.name}
              </Link>)}
            <div className="mt-6" data-id="element-123">
              <BookingButton text="Diagnostic Gratuit" className="w-full" data-id="element-124" />
            </div>
          </div>
        </div>
      </div>
    </header>;
}